import { combineReducers } from 'redux';
import  arrReducer  from './austinReuseDirectory.reducer';

export default combineReducers({
    arrReducer  
});